(ns teamoesterreich.admin-mode.data.eventTask
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))




(defn serialize-path [in]
  (json/serialize in))


(defn <get-event-task-list-elements [event-uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-task/event/" event-uuid)
              (fn [r-list status]
                (log/debug "eventTask-list-elements done" r-list status)
                (when (= status 200)
                  (done-fn (into {} (map (fn [e] [(get e "crowdtaskerTask-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                           )))))

(defn <task-load [uuid cb-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-task/" uuid)
              (fn [r-elem status]
                (log/debug "eventTask done" r-elem status)
                (when (= status 200)
                  (cb-fn (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elem)))))))))


(defn >task-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-task/" uuid)
             (ajax/serialize data)
             (fn [r-list status]
               (log/debug ">task-save done" r-list status)
               (if (= status 200)
                 (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                 (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status )}
                          )))))

(defn >event-add-new-task [event-uuid name cb-fn]
  (ajax/auth-post> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-task" )
              (ajax/serialize (merge {:crowdtaskerEvent-uuid event-uuid
                                      :crowdtaskerTask-active true
                                      :crowdtaskerTask-published false
                                      :crowdtaskerTask-name name}))
              (fn [r-elem status]
                (cb-fn (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elem))))))
              ))




(defn >task-save-polygon [uuid path done-fn]
  (log/out "save new task polygon: " (ajax/serialize {:crowdtaskerTask-uuid (str uuid)
                                                      :crowdtaskerTask-locationPolygonJsonString (serialize-path path)
                                                      }))
  (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-task/"  uuid)
             (ajax/serialize {:crowdtaskerTask-uuid (str uuid)
                              :crowdtaskerTask-locationPolygonJsonString (serialize-path path)
                              :crowdtaskerTask-locationState (str "")
                              :crowdtaskerTask-locationDistrict (str "")
                              })
             (fn [r-list status]
               (log/debug ">task-save done" r-list status)
               (if (= status 200)
                 (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                 (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status )}
                          )))))


(defn >task-save-county-state [uuid state district done-fn]
  (let [body (ajax/serialize {:crowdtaskerTask-uuid (str uuid)
                              :crowdtaskerTask-locationState (str state)
                              :crowdtaskerTask-locationDistrict (str district)
                              :crowdtaskerTask-locationPolygonJsonString (str "")
                              })]
    (log/out "save new path: " body)
    (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-task/"   uuid)
               body
               (fn [r-list status]
                 (log/debug ">task-save done" r-list status)
                 (if (= status 200)
                   (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                   (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status )}
                            ))))))





(defn task-list-update [& [on-finished]]
  (let [uuid (get-in @vstate/app-state [:selected-task :crowdtaskerTask-uuid])]
    (<task-load uuid (fn [response]
                       (swap! vstate/app-state assoc :selected-task response)
                       (when on-finished (on-finished))
                       ))))

(defn task-update [& [on-finished]]
  (let [uuid (get-in @vstate/app-state [:selected-task :crowdtaskerTask-uuid])]
    (<task-load uuid (fn [response]
                       (swap! vstate/app-state assoc :selected-task response)
                       (when on-finished (on-finished))
                       ))))















